<div class="action-arrow__content" *ngIf="canRetry">
	<button class="btn btn-sm cv-btn-blue" (click)="onRetryCall()">
		Retry
	</button>
</div>
